import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import api from '../api';
import { Button, DetailContainer, Header, ProjectInfo } from './Detail.styles';
import logo from '../assets/logo.png';
import { useNavigate } from 'react-router-dom';

const ProfilePage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <DetailContainer>
            <Header>
                <div>
                    <img src={logo} alt="Apply Heating Logo" />
                </div>
                <h2>Profile</h2>
            </Header>
            <Formik
                initialValues={{
                    password: '',
                    confirmPassword: '',
                }}
                validationSchema={Yup.object({
                    password: Yup.string().required('Required'),
                    confirmPassword: Yup.string()
                        .oneOf([Yup.ref('password')], 'Passwords must match')
                        .required('Required'),
                })}
                onSubmit={async (values, { resetForm }) => {
                    try {
                        await api.put(`/api/auth/update-password`, { password: values.password }, {
                            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                        });
                        resetForm();
                        alert('Password updated successfully! Please log in again.');
                        localStorage.removeItem('token');
                        navigate('/login');
                    } catch (error) {
                        console.error('Error updating password', error);
                        alert('Failed to update password.');
                    }
                }}
            >
                {({ values, handleChange, handleBlur, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                        <ProjectInfo>
                            <p><strong>New Password:</strong> <input id="password" name="password" type="password" onChange={handleChange} onBlur={handleBlur} value={values.password} /></p>
                            <p><strong>Confirm Password:</strong> <input id="confirmPassword" name="confirmPassword" type="password" onChange={handleChange} onBlur={handleBlur} value={values.confirmPassword} /></p>
                        </ProjectInfo>
                        <Button type="submit">Update Password</Button>
                    </Form>
                )}
            </Formik>
        </DetailContainer>
    );
};

export default ProfilePage;
